import { useSyncExternalStore } from 'react'
import { SearchEvent } from '../../constants/enums'
import { pubSubSearch } from '../../state/pubSub'
import { SEARCHSTATE } from '../../state/state.search'

const getSearchHistory = () => SEARCHSTATE.history
const getSearchLoading = () => SEARCHSTATE.loading
const getSearchResults = () => SEARCHSTATE.results
const getSearchQuery = () => SEARCHSTATE.query

const subSearchHistory = (callback: () => void) =>
    pubSubSearch.on(SearchEvent.UPDATE_HISTORY, callback)
const subSearchLoading = (callback: () => void) =>
    pubSubSearch.on(SearchEvent.LOADING, callback)
const subSearchQuery = (callback: () => void) =>
    pubSubSearch.on(SearchEvent.UPDATE_QUERY, callback)
const subSearchResults = (callback: () => void) =>
    pubSubSearch.on(SearchEvent.RESULTS, callback)

export const useSearch = () => {
    const query = useSyncExternalStore(
        subSearchQuery,
        getSearchQuery,
        getSearchQuery,
    )
    const loading = useSyncExternalStore(
        subSearchLoading,
        getSearchLoading,
        getSearchLoading,
    )
    const results = useSyncExternalStore(
        subSearchResults,
        getSearchResults,
        getSearchResults,
    )

    return {
        results,
        loading,
        query,
    }
}

export const useHistory = () => {
    const history = useSyncExternalStore(
        subSearchHistory,
        getSearchHistory,
        getSearchHistory,
    )

    return history
}
